import { get } from "lodash";

let mutations = {
  registerChecklist(state, { id }) {
    if (!state.checklists[id]) {
      state.checklists[id] = {
        accordions: {}
      };
    }
  },
  registerAccordion(state, { checklistId, id }) {
    if (!state.checklists[checklistId]) {
      return;
    }

    if (!state.checklists[checklistId].accordions[id]) {
      state.checklists[checklistId].accordions[id] = false;
    }
  },
  setAccordionState(
    state,
    { checklistId, id, open = false, closeOthers = false }
  ) {
    if (closeOthers) {
      Object.keys(state.checklists[checklistId].accordions).map(function(key) {
        state.checklists[checklistId].accordions[key] = false;
      });
    }
    state.checklists[checklistId].accordions[id] = open;
  },
  setItemState(state, { id, value = "", merges = false }) {
    const [checklistId, accordionId] = id.split("/");

    if (state.checklists[checklistId]) {
      state.checklists[checklistId].accordions[accordionId] = false;
    }

    if (merges) {
      const entries = Object.entries(get(state, "states", {}));
      const entry = entries.find(
        entry => entry[0].split("/")[1] === accordionId
      );

      if (entry) {
        state.states[`${entry[0].split("/")[0]}/${accordionId}`] = value;
        return;
      }
    }

    state.states[id] = value;
  }
};

export default mutations;
